export function qs(selector, root = document) {
  return root.querySelector(selector);
}

export function qsa(selector, root = document) {
  return Array.from(root.querySelectorAll(selector));
}

export function showElement(element) {
  if (!element) return;
  element.style.display = element.dataset.legacyDisplay || 'block';
}

export function hideElement(element) {
  if (!element) return;
  if (!element.dataset.legacyDisplay && element.style.display) {
    element.dataset.legacyDisplay = element.style.display;
  }
  element.style.display = 'none';
}

export function toggleText(source, from, to) {
  if (!source) return;
  source.textContent = source.textContent.replace(from, to);
}

export function fadeOutElement(element, durationMs = 200) {
  if (!element) return;
  element.style.transition = `opacity ${durationMs}ms`;
  element.style.opacity = '0';
  window.setTimeout(() => {
    element.hidden = true;
  }, durationMs);
}

export function setFormGroupVisible(formGroup, visible) {
  if (!formGroup) return;
  formGroup.hidden = !visible;
  qsa('input, select, textarea', formGroup).forEach((field) => {
    field.disabled = !visible;
  });
}
